"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryQueryLink = void 0;
const observable_1 = require("@trpc/server/observable");
const should_retry_query_1 = require("../should-retry-query");
/**
 * Creates a link that retries queries failded due to server or network errors.
 * @link https://trpc.io/docs/client/links
 *
 * The original implementation was copied from
 * https://github.com/trpc/trpc/blob/main/packages/client/src/links/internals/retryLink.ts
 *
 * @param opts.attempts The maximum number of attempts to query the data.
 * @returns The retry query link implementation.
 */
function retryQueryLink(opts) {
    // initialized config
    const shouldRetry = (0, should_retry_query_1.shouldRetryQuery)({ attempts: opts.attempts });
    return () => {
        // initialized in app
        return ({ op, next }) => {
            // initialized for request
            return (0, observable_1.observable)((observer) => {
                let next$ = null;
                let attempts = 0;
                let isDone = false;
                function attempt() {
                    attempts = attempts + 1;
                    next$?.unsubscribe();
                    next$ = next(op).subscribe({
                        error(error) {
                            if (op.type === "query" && shouldRetry(attempts, error)) {
                                attempt(); // retry query
                                return;
                            }
                            observer.error(error);
                        },
                        next(result) {
                            observer.next(result);
                        },
                        complete() {
                            if (isDone) {
                                observer.complete();
                            }
                        },
                    });
                }
                attempt();
                return () => {
                    isDone = true;
                    next$?.unsubscribe();
                };
            });
        };
    };
}
exports.retryQueryLink = retryQueryLink;
//# sourceMappingURL=retry-query.link.js.map